import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 分享用户身份
 */
class operatorRole extends UltMeta {
    SHIPPING = new Meta(1, "船主");
    OWNER = new Meta(2, "货主");
    ADMIN = new Meta(3, "后台用户");
}

export const OPERATOR_ROLE = new operatorRole();

/**
 * 分享端类型
 */
class clientType extends UltMeta {
    APP = new Meta(2, "船务app");
    MINI_PROGRAM = new Meta(3, "船务小程序");
    ADMIN = new Meta(5, "管理后台");
}

export const CLIENT_TYPE = new clientType();

/**
 * 分享入口
 */
class operationEntry extends UltMeta {
    DEMAND = new Meta(1, "需求详情");
    FIND_SHIPPING = new Meta(2, "找船运单详情");
    EMPTY_SHIP_DETAIL = new Meta(3, "空船详情");
    DEMALL_EMPTY_SHIP_DETAIL = new Meta(4, "需求大厅空船详情");
}

export const OPERATION_ENTRY = new operationEntry();

/**
 * 分享方式
 */
class operatorMethod extends UltMeta {
    WE_CHAT_NATIVE = new Meta(1, "微信原生分享");
    CUSTOMIZATION = new Meta(2, "自定义分享");
}

export const OPERATOR_METHOD = new operatorMethod();

/**
 * 分享载体
 */
class operatorCarrier extends UltMeta {
    MINI_PROGRAM_CARD = new Meta(1, "小程序卡片");
    GENERATE_POSTERS = new Meta(2, "生成海报");
}

export const OPERATOR_CARRIER = new operatorCarrier();
